module.exports = __webpack_public_path__ + "img/banner.a2bba3c3.jpg";